var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon } from "../../UI";
import { withContext } from "../../componentWrappers";
import { I18NLink, t } from "../../I18N";

import { switchOneUpEntity, toggleOneUpFullEdit } from "../actions/actions";
import { selectIsPristine, selectOneUpState } from "../common";

const defaultProps = {
  isPristine: true,
  oneUpState: {},
  switchOneUpEntity: (_delta, _save) => {},
  mainContext: { confirm: (_props) => {} }
};



class OneUpTitleBarBase extends Component {


  backToThesaurus() {
    const { oneUpState, isPristine } = this.props;
    if (oneUpState.reviewThesaurusName) {
      return /*#__PURE__*/(
        _jsx(I18NLink, {
          to: `/settings/dictionaries/cockpit/${oneUpState.reviewThesaurusId}`,
          className: "btn btn-default",
          confirmTitle: isPristine ? '' : 'Confirm discard changes',
          confirmMessage:
          isPristine ?
          '' :
          'There are unsaved changes. Are you sure you want to discard them and navigate away?' }, void 0, /*#__PURE__*/


        _jsx(Icon, { icon: "arrow-left" }), /*#__PURE__*/
        _jsx("span", { className: "btn-label" }, void 0,
        t('System', 'Back to'), " ", /*#__PURE__*/_jsx("span", {}, void 0, `'${oneUpState.reviewThesaurusName}'`)
        )
        ));

    }
    return null;
  }

  navButtons() {
    const { oneUpState, isPristine } = this.props;
    const prevClass = oneUpState.indexInDocs > 0 ? '' : ' btn-disabled';
    const nextClass = oneUpState.indexInDocs < oneUpState.totalDocs - 1 ? '' : ' btn-disabled';
    const navAction = isPristine ?
    (delta) => () => this.props.switchOneUpEntity(delta, false) :
    (delta) => () =>
    this.props.mainContext.confirm({
      accept: () => this.props.switchOneUpEntity(delta, false),
      title: 'Confirm discard changes',
      message:
      'There are unsaved changes. Are you sure you want to discard them and switch to a different document?'
    });
    return /*#__PURE__*/(
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: navAction(-1), className: `btn btn-default${prevClass}` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-left" })
      ), /*#__PURE__*/
      _jsx("button", { type: "button", onClick: navAction(+1), className: `btn btn-default${nextClass}` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" })
      )
      ));

  }

  render() {
    const { oneUpState } = this.props;

    return /*#__PURE__*/(
      _jsx("div", { className: "content-header-title" }, void 0,
      this.backToThesaurus(),
      oneUpState.reviewThesaurusValues && oneUpState.reviewThesaurusValues.length === 1 ? /*#__PURE__*/
      _jsx("span", { className: "large" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "space8" }),
      t('System', 'Documents including suggestion:'), ' ', /*#__PURE__*/
      _jsx("b", {}, void 0, `'${oneUpState.reviewThesaurusValues[0]}'`), /*#__PURE__*/
      _jsx("span", { className: "separator" })
      ) : /*#__PURE__*/

      _jsx("span", { className: "large" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "space8" }),
      t('System', 'Documents for custom filter'), /*#__PURE__*/
      _jsx("span", { className: "separator" })
      ),

      oneUpState.totalDocs ? /*#__PURE__*/
      _jsx("div", {}, void 0,
      t('System', 'Document'), " ", /*#__PURE__*/_jsx("span", {}, void 0, oneUpState.indexInDocs + 1), " ", t('System', 'of'), ' ', /*#__PURE__*/
      _jsx("span", {}, void 0,
      oneUpState.totalDocs >= oneUpState.maxTotalDocs ?
      `>${oneUpState.totalDocs - 1}` :
      `${oneUpState.totalDocs}`
      ), /*#__PURE__*/
      _jsx("span", { className: "space8" })
      ) :

      t('System', 'No Documents found'),

      this.navButtons()
      ));

  }
}_defineProperty(OneUpTitleBarBase, "defaultProps", defaultProps);

const mapStateToProps = (state) => {var _selectOneUpState;return {
    isPristine: selectIsPristine(state),
    oneUpState: (_selectOneUpState = selectOneUpState(state)) !== null && _selectOneUpState !== void 0 ? _selectOneUpState : {}
  };};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      switchOneUpEntity,
      toggleOneUpFullEdit
    },
    dispatch
  );
}

export { OneUpTitleBarBase };

export const OneUpTitleBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(withContext(OneUpTitleBarBase));